import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Calendar as PRCalendar } from 'primereact/calendar';
import { showToast } from "../ToastManager";
import { Button } from 'primereact/button';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import ptBrLocale from '@fullcalendar/core/locales/pt-br';
import Utils from '../../utilities/Utils';

import AgendamentoService from '../../service/AgendamentoService';
import RoleService from '../../service/RoleService';
import UsuarioService from '../../service/UsuarioService';

const usuarioService = new UsuarioService();
const agendamentoService = new AgendamentoService();

const CalendarioAgendamento = () => {

    const agendamento = [{
        id: '',
        title: '',
        start: '',
        end: '',
        extendedProps: {
            client: '',
            prestador: '',
            description: ''
        },
    }]

    const typeColors = {
        'AGENDADO': 'calendar-status status-agendado',
        'PAGAMENTO': 'calendar-status status-pagamento',
        'CANCELADO': 'calendar-status status-cancelado',
        'CONFIRMADO': 'calendar-status status-confirmado',
        'CONCLUIDO': 'calendar-status status-concluido',
        // Adicione mais mapeamentos conforme necessário
    };

    const [eventDialog, setEventDialog] = useState(false);
    const [clickedEvent, setClickedEvent] = useState(agendamento);
    const [events, setEvents] = useState(null);
    const [loading1, setLoading1] = useState(false);
    const [status, setStatus] = useState('');
    const [selectedStatus, setSelectedStatus] = useState(null);

    const statusList = ['AGENDADO', 'PAGAMENTO', 'CONFIRMADO', 'CANCELADO', 'CONCLUIDO']
    const iss = localStorage.getItem('iss');
    const { id } = useParams();

    let roles = JSON.parse(localStorage.getItem('roles'));

    const eventClick = (e) => {
        setEventDialog(true);
        setClickedEvent(e.event);
        setSelectedStatus(e.event.extendedProps.status)
    }

    const initAgendamento = useCallback(async () => {
        setLoading1(true);
        try {
            const dataInicial = Utils.formatDataAddRemoveDays(null, 365, "-")
            const dataFinal = Utils.formatDataAddRemoveDays(null, 365, "+")

            const data = await agendamentoService.listAllAgendamentos(iss, dataInicial, dataFinal);

            let events = data.data.map(e => ({
                id: e.id,
                title: e.prestadorTipoAgendamento.tipoAgendamento.nome,
                start: `${e.data_agendamento}T${e.hora_inicio}`,
                end: `${e.data_agendamento}T${e.hora_fim}`,
                extendedProps: {
                    client: e.user.profile.name,
                    prestador: e.prestadorTipoAgendamento.prestador.nome,
                    description: e.observacoes,
                    status: e.status
                }
            }));
            setEvents(events);
            setLoading1(false);

            /* if (id != null) {
            } else {
                agendamentoService.listAllAgendamento(iss).then(data => {
                    let events = data.data.length > 0 ? data.data.map(e => ({
                        id: e.id,
                        title: e.prestadorTipoAgendamento.tipoAgendamento.nome,
                        start: `${e.data_agendamento}T${e.hora_inicio}`,
                        end: `${e.data_agendamento}T${e.hora_fim}`,
                        extendedProps: {
                            client: e.user.profile.name,
                            prestador: e.prestadorTipoAgendamento.prestador.nome,
                            description: e.observacoes,
                            status: e.status
                        }
                    })) : [];
                    setEvents(events);
                    setLoading1(false);
                });
            } */
        } catch (e) {
            console.log(e)
        }
    }, [iss])

    useEffect(() => {
        if (!events)
            initAgendamento()
    }, [events, initAgendamento])


    const save = () => {
        if (roles.changeStatus) {
            setLoading1(true)
            agendamentoService.changeStatus(iss, clickedEvent.id, selectedStatus).then((data) => {
                showToast({ severity: 'success', summary: 'Sucesso', detail: 'Status do agendamento alterado com sucesso!' });
                setLoading1(false);
                setEventDialog(false)
                initAgendamento();
            }, error => {
                showToast({ severity: 'error', summary: 'Erro ao editar', detail: 'Erro ao editar agenda' });
                setEventDialog(false)
            }).finally(() => { setLoading1(false) });
        }
    }

    const footer = (
        <>
            <Button type="button" label="Atualizar" icon="pi pi-check" className="p-button-text" onClick={save} />
            {/* <Button type="button" label="Reset" icon="pi pi-refresh" className="p-button-text" onClick={reset} /> */}
        </>
    );

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card calendar-demo">

                    <FullCalendar
                        locale={ptBrLocale}
                        events={events}
                        eventClassNames={(arg) => {
                            const type = arg.event.extendedProps.status;
                            return [typeColors[type]];
                        }} eventClick={eventClick} initialDate={Utils.formatDataAddRemoveDays(null, 0, "+")} initialView='dayGridMonth' plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                        headerToolbar={{ left: 'prev,next today', center: 'title', right: 'dayGridMonth,timeGridWeek,timeGridDay' }} editable selectable selectMirror dayMaxEvents />

                    <Dialog visible={eventDialog && !!clickedEvent} style={{ width: '450px' }} header="Detalhes do agendamento" footer={footer} modal closable onHide={() => setEventDialog(false)}>
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-12">
                                <span class="text-900 font-semibold block mb-2">Tipo Agendamento</span>
                                <span class="block mb-3">{clickedEvent.title} </span>
                            </div>
                            <div className="field col-12 md:col-12">
                                <span class="text-900 font-semibold block mb-2">Prestador</span>
                                <span class="block mb-3">{clickedEvent.extendedProps ? clickedEvent.extendedProps.prestador : null}</span>
                            </div>
                            <div className="field col-12 md:col-12">
                                <span class="text-900 font-semibold block mb-2">Cliente</span>
                                <span class="block mb-3">{clickedEvent.extendedProps ? clickedEvent.extendedProps.client : null}</span>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="start">Início</label>
                                <PRCalendar id="start" disabled value={clickedEvent.start} showTime appendTo={document.body} />
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="end">Fim</label>
                                <PRCalendar id="end" disabled value={clickedEvent.end} showTime appendTo={document.body} />
                            </div>
                            <div className="field col-12 md:col-12">
                                <span class="text-900 font-semibold block mb-2">Observação</span>
                                <span calss="block mb-3">{clickedEvent.description}</span>
                            </div>
                            <div className="field col-12 md:col-12">
                                <label htmlFor="status">Status</label>
                                <Dropdown optionLabel="status" value={selectedStatus}
                                    options={statusList}
                                    onChange={(e) => {
                                        setSelectedStatus(e.value)
                                    }} />
                            </div>
                        </div>
                    </Dialog>
                </div>
            </div>
        </div>
    )
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(CalendarioAgendamento, comparisonFn);
